module.exports = __webpack_public_path__ + "img/ry12.28fda27d.jpeg";